import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const columns = [
  {
    id: 'work_order_id',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.workOrderNo'),
  },
  {
    id: 'unitId',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('vehicles.unitId'),
  },
  {
    id: 'vin',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('vehicles.vin'),
  },
  {
    id: 'mechanicName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.mechanic'),
  },
  {
    id: 'driverName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.driver'),
  },
  {
    id: 'unitType',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.unitType'),
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('companyData.assetsType'),
  },
  {
    id: 'reported_date',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.reportedDate'),
  },
  {
    id: 'scheduled_date',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.scheduledDate'),
  },
  {
    id: 'due_date',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.dueDate'),
  },
  {
    id: 'repair_cost',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.repairCost'),
  },
  {
    id: 'report',
    numeric: false,
    needSorting: true,
    disablePadding: false,
    label: i18n.t('workOrders.inspectionReport'),
  },
  {
    id: 'workOrderType',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.serviceType'),
  },
  checkServiceProvider('config_dvirLocation', window.$environment.SERVICE_PROVIDER, false) && {
    id: 'dvirLocation',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.dvirLocation'),
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('Status'),
  },
  {
    id: 'actions',
    label: i18n.t('Actions'),
  },
];

export const sortColumnMapping = {
  report: 'inspection.report',
  status: 'state',
  workOrderType: 'type',
  repair_cost: 'cost',
  due_date: 'endDate',
  scheduled_date: 'beginDate',
  reported_date: 'createDate',
  type: 'assetType',
  work_order_id: 'idPub',
  mechanicName: 'mechanicName',
  driverName: 'driverName',
  unitType: 'unitType',
  unitId: 'vehicleName',
  vin: 'vin',
};

export const basicRequest = {
  displayLength: '10',
  displayStart: '1',
  state: 'OPEN',
};
